module.exports = __webpack_public_path__ + "static/media/slack.b3da4cdc.svg";